import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "separator"];
import React from 'react';
import Item from './Item';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
var Breadcrumb = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-breadcrumb',
      className,
      separator = '/'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("div", _extends({}, _extends({
    className: cls
  }, other), {
    ref: ref,
    children: React.Children.map(props.children, element => {
      return /*#__PURE__*/React.cloneElement(element, Object.assign({
        separator
      }, element.props, {}));
    })
  }));
});
Breadcrumb.Item = Item;
export default Breadcrumb;
export { Breadcrumb };